import { usePageCharts } from '~/api/hooks/useCharts'
import {
  useReviewPageState,
  useComparisonState,
  ReviewPageScaffold,
  PageTiles,
} from '~/components/ReviewPage'
import { PAGE_DEFAULTS } from '~/components/ReviewPage/pageDefaults'

export function CampaignPerformance() {
  const state = useReviewPageState({
    pageId: 'CampaignPerformance',
    // #16 (WP-0): re-point off the throwaway `model_tracking_granular` duplicate. Verified
    // transparent — api.get_controls('model_tracking') is byte-identical (same 9 KPI items,
    // dims_view, min/max dates), and no chart_registry row binds to the granular fact.
    factTable: 'model_tracking',
    defaultKpi: PAGE_DEFAULTS.CampaignPerformance,
    archetype: 'performance',
    multiTimeframe: true,
  })
  const compare = useComparisonState(state.fromIso, state.toIso)
  const charts = usePageCharts(state.pageId, state.kpi)
  return (
    <ReviewPageScaffold
      title="Campaign Performance"
      state={state}
      compare={compare}
      showComparison={false}
      showGranularity={false}
    >
      <PageTiles charts={charts} state={state} compare={compare} pageSlug="campaignperformance" />
    </ReviewPageScaffold>
  )
}
